import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    campaignPosts: gql`
        query CampaignPosts($campaignID: String!, $offset: Int, $limit: Int, $searchQuery: String, $clusterID: String, $filters: [FilterParams]) {
            campaignPostsV2(campaignID: $campaignID, queryOptions: { searchQuery: $searchQuery, clusterID: $clusterID, filters: $filters }, paginationToken: { offset: $offset, limit: $limit }) {
                posts {
                    ...PostWithSensitiveDataFragment
                }
                totalPostCount
            }
        }
        ${fragments.postWithSensitiveData}
        ${fragments.image}
        ${fragments.audio}
    `,
};
